import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/assetAccessorys/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/assetAccessorys/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/assetAccessorys/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/assetAccessorys/delete',
    method: 'post',
    data
  })
}

export function saveBatchUpdate(data) {
  return request({
    url: '/assetAccessorys/saveBatchUpdate',
    method: 'post',
    data
  })
}

// 配件收回
export function recovery(data) {
  return request({
    url: '/assetAccessorys/recovery',
    method: 'post',
    data
  })
}

// 配件使用
export function use(data) {
  return request({
    url: '/assetAccessorys/use',
    method: 'post',
    data
  })
}
